module.exports = __webpack_public_path__ + "static/media/bnb-logo.9faf561e.png";